export default __webpack_public_path__ + "c1117ffc8855673d0172c55da3f71849.ttf";